import React from 'react';
import styles from './formsBrowser.module.scss';
import { useTranslation } from 'react-i18next';
import { FormsHomeFilters } from './FormsHomeFilters';
import { FormsHomeGallery } from './FormsHomeGallery';
import { FilterProps, SelectionProps } from './types/FormTypes';

export const FormsHome = React.memo(
    (props: { selectionProps: SelectionProps; filterProps: FilterProps }) => {
        const { t } = useTranslation();

        try {
            const { selectionProps, filterProps } = props;

            return (
                <div className={styles.formsHomeContainer}>
                    <div className={styles.formsHomeTitleContainer}>
                        {t('FormsBrowser.HomeTitle')}
                    </div>
                    <div className={styles.formsHomeDescriptionContainer}>
                        {t('FormsBrowser.HomeDescription')}
                    </div>
                    <FormsHomeFilters filterProps={filterProps} />
                    <FormsHomeGallery
                        selectionProps={selectionProps}
                        filterProps={filterProps}
                    />
                </div>
            );
        } catch {
            return null;
        }
    },
);
